import React, { useState } from "react";
import { Checkbox } from "@blueprintjs/core";
import styles from "./SelectList.module.scss";

export function SelectItem({ value, setValue, data }) {
  const isIncluded = value.indexOf(data.value) !== -1;

  const removeValue = () => {
    let newVal = value.filter((id) => id !== data.value);
    setValue(newVal);
  };

  const addValue = () => {
    !isIncluded && setValue([data.value, ...value]);
  };

  const onChange = (event) => {
    event.target.checked ? addValue() : removeValue();
  };

  return (
    <Checkbox
      onChange={onChange}
      checked={isIncluded}
      className={styles.checkBox}
      large={true}
    >
      <span className={styles.checkBoxLabel}>
        {data.imageUrl && <img src={data.imageUrl} />}
        {data.text}
      </span>
    </Checkbox>
  );
}
